import React from 'react';

import { DocumentEditDialog } from './DocumentEditDialog';

export const DocumentsDialogs = ({
	uploaded,
	hideEditDialog,
	resetUploaded,
	updateDocument,
	typeChoices,
}) => {
	return (
		<React.Fragment>
			{uploaded && !hideEditDialog && (
				<DocumentEditDialog
					open
					handleClose={resetUploaded}
					doc={uploaded}
					handleSave={updateDocument}
					typeChoices={typeChoices}
				/>
			)}
		</React.Fragment>
	);
};
